var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5729_3444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5729_3444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1386 19.1875L5.99223 12.7943V10.9963H9.22407C10.0702 10.9963 10.8028 10.7416 11.4217 10.2324C12.0407 9.72311 12.4128 9.04932 12.5382 8.211H5.05206V6.44818H12.3384C12.1033 5.86058 11.7018 5.3807 11.1338 5.00855C10.5658 4.6364 9.9292 4.45032 9.22407 4.45032H5.05206V2.6875H16.2166V4.45032H13.1728C13.4157 4.74021 13.6272 5.0536 13.8074 5.39049C13.9876 5.72739 14.1247 6.07995 14.2187 6.44818H16.2166V8.211H14.3127C14.1874 9.54291 13.6448 10.6339 12.6851 11.484C11.7253 12.334 10.5716 12.7591 9.22407 12.7591H8.40142L14.583 19.1875H12.1386Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupee);
export default __webpack_public_path__ + "static/media/currency_rupee.5eb8dfd0fea30b09487449745a06e971.svg";
export { ForwardRef as ReactComponent };